/* eslint-disable react/prop-types */
import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../api';

const PharmacyContext = createContext(null);

export function PharmacyProvider({ children }) {
  const [pharmacies, setPharmacies] = useState([]);
  const [selectedPharmacy, setSelectedPharmacy] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPharmacies = () => {
      if (!localStorage.getItem('token')) return;
      api.pharmacy.listPharmacies()
        .then((res) => {
          const list = res.data || [];
          setPharmacies(list);
          const savedId = localStorage.getItem('selectedPharmacyId');
          const match = savedId ? list.find((p) => String(p.id) === savedId) : null;
          const defaultPick = match || list.find((p) => p.is_default === 'Y') || list[0] || null;
          if (defaultPick) {
            setSelectedPharmacy(defaultPick);
            localStorage.setItem('selectedPharmacyId', String(defaultPick.id));
          }
        })
        .catch(() => {})
        .finally(() => setLoading(false));
    };

    fetchPharmacies();
    window.addEventListener('auth:login', fetchPharmacies);
    return () => window.removeEventListener('auth:login', fetchPharmacies);
  }, []);

  const selectPharmacy = (pharmacy) => {
    setSelectedPharmacy(pharmacy);
    localStorage.setItem('selectedPharmacyId', String(pharmacy.id));
  };

  return (
    <PharmacyContext.Provider value={{ pharmacies, selectedPharmacy, loading, selectPharmacy }}>
      {children}
    </PharmacyContext.Provider>
  );
}

export function usePharmacy() {
  return useContext(PharmacyContext);
}
